import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemActionParamIndexComponent } from './crud-index/crud-index.component';
import { SystemActionParamCESComponent } from './crud-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: SystemActionParamIndexComponent,
  },
  {
    path: 'new',
    component: SystemActionParamCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: SystemActionParamCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: SystemActionParamCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemActionParamsRoutingModule {}
